"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.calculateTotalFees = function (loanAmount, isSecured, isPrivateSale, establishmentFeesByMaximumLoanAmount, ppsrFee, privateSaleFee) {
  var _a;

  var establishmentFee = ((_a = establishmentFeesByMaximumLoanAmount === null || establishmentFeesByMaximumLoanAmount === void 0 ? void 0 : establishmentFeesByMaximumLoanAmount.sort(function (a, b) {
    return a.maximumLoanAmount - b.maximumLoanAmount;
  }).find(function (fee) {
    return loanAmount <= fee.maximumLoanAmount;
  })) === null || _a === void 0 ? void 0 : _a.establishmentFee) || 0;
  return establishmentFee + (isSecured && ppsrFee || 0) + (isSecured && isPrivateSale && privateSaleFee || 0);
};